export const CancelContent = {
  linkText: `Quit`,
  modalHeader: `Are you sure you want to quit?`,
  modalText: `By quitting, any information you've entered up to this point won't be saved.`,
  yes: `Yes`,
  no: `No`,
  stay: `Stay`,
  quit: `Quit`,
  saveAndQuit: {
    linkTextSaveAndQuit: `Save & quit`,
    modalHeader: `Are you sure?`,
    startingWord: 'Select ',
    modalText: ` to save what you've entered so far. Your saved transfer request will be available until `,
    modalTextBeforeLink: `. You can also `,
    startOverLinkLabel: 'start over',
    modalTextAfterLink: ` from the beginning.`,
    modalText2:
      "To retrieve your saved draft, just reenter the inheritance experience, and we'll prompt you with the drafts you've got in progress.",
    saveAndQuitButtonLabel: `Save and quit`,
    deleteDraftButtonLabel: `Delete draft`,
    inheritancePersonalInfoLink: 'inheritance/personal-info',
    multiDecedentInfoLink: 'secure/multi-inheritance/decedent-info',
  },
};
